import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticSuccessStoriesComponent } from './static-success-stories/static-success-stories.component';
import { NgxGlideModule } from 'ngx-glide';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [StaticSuccessStoriesComponent],
  imports: [
    CommonModule,
    NgxGlideModule,
    SharedModule
  ],
  exports: [StaticSuccessStoriesComponent],
})
export class StaticSuccessStoriesModule { }
